import React, { PureComponent } from 'react';
import { Link, Redirect } from 'react-router-dom';
import swal from 'sweetalert';
import EditProfileModal from './EditProfileModal';
import CommonService from '../../../services/CommonService';

export default class TopbarProfile extends PureComponent {
  constructor() {
    super();
    this.state = {
      collapse: false,
      modal: false,
      loggedIn: true,
    };
    this.logout = this.logout.bind(this);
    this.toggleEditProfileModal = this.toggleEditProfileModal.bind(this);
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  editSubmitForm = (e) => {
    e.preventDefault();
    const { formdata } = this.state;
    this.userdata = JSON.parse(localStorage.getItem('userData'));
    formdata.user_id = this.userdata.user_id;
    if (formdata.name && formdata.oldPassword) {
      if (formdata.newPassword) {
        const params = { name: formdata.name, password: formdata.newPassword };
        if (formdata.newPassword.length >= 8) {
          CommonService.getRows(`check_user_credentials/${formdata.user_id}/${formdata.oldPassword}`).then((result) => {
            if (result) {
              CommonService.updateData(`update_single_row/users/user_id/${formdata.user_id}`, params).then((result2) => {
                if (result2 === 1) {
                  this.userdata.name = formdata.name;
                  localStorage.setItem('userData', JSON.stringify(this.userdata));
                  swal({
                    title: '',
                    text: 'Successfully updated user information!',
                    type: 'success',
                  }).then(() => {
                      window.location.reload();
                  });
                } else {
                  this.setState({ errorMsg: 'Error occurred.' });
                }
              }).catch((error) => {
                this.setState({ errorMsg: 'Connection error.' });
                console.log(error);
              });
            } else {
              this.setState({ errorMsg: 'In Correct Password.' });
            }
          }).catch((error) => {
            this.setState({ errorMsg: 'Connection error.' });
            console.log(error);
          });
        } else {
          this.setState({ errorMsg: 'New password requires 8 characters atleast.' });
        }
      } else {
        const params = { name: formdata.name };
        CommonService.getRows(`check_user_credentials/${formdata.user_id}/${formdata.oldPassword}`).then((result) => {
          if (result) {
            CommonService.updateData(`update_single_row/users/user_id/${formdata.user_id}`, params).then((result2) => {
              if (result2 === 1) {
                this.userdata.name = formdata.name;
                localStorage.setItem('userData', JSON.stringify(this.userdata));
                swal({
                  title: '',
                  text: 'Successfully updated user information!',
                  type: 'success',
                }).then(() => {
                    window.location.reload();
                });
              } else {
                this.setState({ errorMsg: 'Error occurred.' });
              }
            }).catch((error) => {
              this.setState({ errorMsg: 'Connection error.' });
              console.log(error);
            });
          } else {
            this.setState({ errorMsg: 'In Correct Password.' });
          }
        }).catch((error) => {
          this.setState({ errorMsg: 'Connection error.' });
          console.log(error);
        });
      }
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  handleChange = (e, fieldName) => {
    if (fieldName === 'id') {
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, user_id: e.value },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  };

  toggleEditProfileModal() {
    this.setState(prevState => ({ modal: !prevState.modal }));
    this.handleSubmit = (e) => { this.editSubmitForm(e); };
  }

  logout(e) {
    e.preventDefault();
    const { loggedIn } = this.state;
    if (loggedIn) {
      localStorage.removeItem('userData');
      this.setState({ loggedIn: false });
    }
  }

  render() {
    const {
      loggedIn,
      modal,
      errorMsg,
      formdata,
    } = this.state;
    if (loggedIn === false || localStorage.getItem('userData') == null) {
      return (<Redirect to="/login" />);
    }

    return (
      <>
        <EditProfileModal
          title="Manage Account"
          modal={modal}
          showPassField={this.showPassField}
          postValue={formdata}
          toggle={this.toggleEditProfileModal}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          errorMsg={errorMsg}
        />
        <div className="topbar__profile" style={{ marginLeft: 0 }}>
          <button className="topbar__avatar" type="button" style={{ padding: 0 }} onClick={() => this.toggleEditProfileModal()}>
            <div className="topbar__link logout">
              <span className="topbar__link-icon lnr lnr-user" />
              <p className="topbar__link-title">Account</p>
            </div>
          </button>
        </div>
        <div className="topbar__profile" style={{ marginLeft: 0 }}>
          <button className="topbar__avatar" type="button" style={{ padding: 0 }} onClick={this.toggle}>
            <Link className="topbar__link logout" to="/" onClick={this.logout}>
              <span className="topbar__link-icon lnr lnr-exit" />
              <p className="topbar__link-title">Log Out</p>
            </Link>
          </button>
        </div>
      </>
    );
  }
}
